import { todayKST } from '../../../utils/date';

export const INITIAL_FILTERS = {
  source: '',
  sourceGroup: '',
  action: '',
  actionGroup: '',
  search: '',
  person: '',
  company: '',
  month: '',
  dateFrom: '',
  dateTo: '',
};

export const DEFAULT_ACTION_OPTIONS = [
  { value: '', label: '전체' },
  { value: 'create', label: '등록' },
  { value: 'update', label: '수정' },
  { value: 'delete', label: '삭제' },
  { value: 'cancel', label: '취소' },
  { value: 'restore', label: '복원' },
  { value: 'calculate', label: '계산' },
  { value: 'confirm', label: '확정' },
  { value: 'reopen', label: '확정 취소' },
  { value: 'grant', label: '배정' },
  { value: 'revoke', label: '회수' },
  { value: 'correct', label: '정정' },
  { value: 'bulk_create', label: '일괄 생성' },
  { value: 'bulk_update', label: '일괄 수정' },
  { value: 'settle', label: '정산' },
  { value: 'upload', label: '업로드' },
  { value: 'apply', label: '적용' },
  { value: 'reset_password', label: '비밀번호 초기화' },
  { value: 'impersonate', label: '위장접속' },
];

export const QUICK_FILTERS = [
  { key: 'today', label: '오늘' },
  { key: 'this_month', label: '이번달' },
  { key: 'reservations', label: '예약' },
  { key: 'settlement_payout', label: '정산지급' },
  { key: 'delete_restore', label: '삭제/복원' },
  { key: 'permissions', label: '권한 배정/회수' },
  { key: 'leaves', label: '연차 변경' },
  { key: 'password_resets', label: '비밀번호 초기화' },
  { key: 'payroll', label: '급여' },
  { key: 'promotional', label: '홍보물' },
  { key: 'impersonation', label: '위장접속' },
];

function keepNarrowFilters(filters) {
  return {
    ...INITIAL_FILTERS,
    company: filters.company || '',
    person: filters.person || '',
  };
}

export function makeQuickFilterFilters(key, currentFilters) {
  const today = todayKST();
  const base = keepNarrowFilters(currentFilters);
  if (key === 'today') return { ...base, dateFrom: today, dateTo: today };
  if (key === 'this_month') return { ...base, month: today.slice(0, 7) };
  if (key === 'reservations') return { ...base, source: 'reservations' };
  if (key === 'settlement_payout') return { ...base, source: 'settlement_payout' };
  if (key === 'delete_restore') return { ...base, actionGroup: 'delete_restore' };
  if (key === 'permissions') return { ...base, source: 'permissions' };
  if (key === 'leaves') return { ...base, source: 'leaves' };
  if (key === 'password_resets') return { ...base, source: 'password_resets' };
  if (key === 'payroll') return { ...base, sourceGroup: 'payroll' };
  if (key === 'promotional') return { ...base, sourceGroup: 'promotional' };
  if (key === 'impersonation') return { ...base, source: 'impersonation' };
  return base;
}

export function isQuickFilterActive(key, filters) {
  const today = todayKST();
  if (key === 'today') return filters.dateFrom === today && filters.dateTo === today;
  if (key === 'this_month') return filters.month === today.slice(0, 7);
  if (key === 'reservations') return filters.source === 'reservations';
  if (key === 'settlement_payout') return filters.source === 'settlement_payout';
  if (key === 'delete_restore') return filters.actionGroup === 'delete_restore';
  if (key === 'permissions') return filters.source === 'permissions';
  if (key === 'leaves') return filters.source === 'leaves';
  if (key === 'password_resets') return filters.source === 'password_resets';
  if (key === 'payroll') return filters.sourceGroup === 'payroll';
  if (key === 'promotional') return filters.sourceGroup === 'promotional';
  if (key === 'impersonation') return filters.source === 'impersonation';
  return false;
}
